import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from '../lib/utils';

type BaseLabelProps = {
    className?: string;
    disabled?: boolean;
};

export type LabelAsLabelProps = BaseLabelProps & ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & { asDiv?: false };
export type LabelAsDivProps = BaseLabelProps & ComponentPropsWithoutRef<'div'> & { asDiv?: true };

export type LabelProps = LabelAsLabelProps | LabelAsDivProps;

const defaultClassName = 'text-sm font-medium cursor peer-disabled:cursor-not-allowed peer-disabled:opacity-70';

export function Label(props: LabelAsDivProps): ReactNode;
export function Label(props: LabelAsLabelProps): ReactNode;
export function Label(props: LabelProps): ReactNode {
    const { className, disabled, asDiv = false, ...rest } = props;

    if (asDiv) {
        return (
            <div
                className={cn(
                    defaultClassName,
                    disabled && 'cursor-not-allowed opacity-70',
                    className,
                )}
                {...(rest as LabelAsDivProps)}
            />
        );
    }

    return (
        <LabelPrimitive.Root
            className={cn(
                defaultClassName,
                disabled && 'cursor-not-allowed opacity-70',
                className,
            )}
            {...(rest as LabelAsLabelProps)}
        />
    );
}

Label.displayName = 'Label';
